export default __webpack_public_path__ + "static/media/atropos.65e18f57.png";